import React from 'react';

// This gateway URL is intentionally permanent. The backend redirects it to
// the current APK, Drive, or Play Store URL configured in its environment.
export const SKILL_SHARE_APK_URL = 'https://online.topskilled.in/download/skillshare';

const SKILL_SHARE_QR_URL = `https://api.qrserver.com/v1/create-qr-code/?size=320x320&margin=12&data=${encodeURIComponent(SKILL_SHARE_APK_URL)}`;

export default function AuthAppDownload({ mobile = false }) {
  const downloadButton = (
    <a
      className="auth-app-download-button"
      href={SKILL_SHARE_APK_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Download the Skill Share Android app"
    >
      <i className="bi bi-download" aria-hidden="true" />
      <span>{mobile ? 'Download the App' : 'Download Now'}</span>
    </a>
  );

  return (
    <section className={`auth-app-download ${mobile ? 'is-mobile' : 'is-desktop'}`} aria-label="Download the Skill Share mobile app">
      {mobile ? downloadButton : (
        <div className="auth-app-download-panel">
          <strong>Scan to download</strong>
          <img
            src={SKILL_SHARE_QR_URL}
            alt="QR code to download the Skill Share Android app"
            referrerPolicy="no-referrer"
          />
          <span className="auth-app-download-copy">Learn anytime, anywhere<br />with Skill Share</span>
          {downloadButton}
        </div>
      )}
    </section>
  );
}
